import classNames from "classnames/bind";
import { TopLevelNavigation } from "@header";

import styles from './LinkList.module.scss';
import SecondaryLink from "../SecondaryLink/SecondaryLink";
const cx = classNames.bind(styles);

type LinkListProps = NonNullable<TopLevelNavigation[number]["linkGroups"]>[number];

export default function LinkList(props: LinkListProps) {
  const { links } = props;
  return (
    <ul className={cx("link-list")}>
      {links?.map((link, index) => (
        <li className={cx("item")} key={index}>
          <SecondaryLink {...link} />
        </li>
      ))}
    </ul>
  );
};
